import React from 'react';
import { Center, Image, Text, VStack } from '@chakra-ui/react';

import { useDepositResultSummary } from '../../../../hooks/use-deposit-result-summary.hook';
import { ExpiredItemsSummary } from '../ExpiredItemsSummary/ExpiredItemsSummary';

const getIconPath = (iconName: string) => require(`../../../../../../../assets/icons/${iconName}`);

export const DepositSummaryFooter = () => {
  const { successItems, depositSummaryText, depositIcon } = useDepositResultSummary();

  if (!successItems.length) {
    return null;
  }

  return (
    <Center pt={2} px={8}>
      <VStack w={'100%'}>
        <ExpiredItemsSummary />
        <>
          <Image src={getIconPath(depositIcon)} alt="money" display="inline-block" w={100} maxW={100} />
          <Text fontSize="20px" color="grey.200">
            {depositSummaryText}
          </Text>
        </>
      </VStack>
    </Center>
  );
};
